import React from "react";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

const NimbusResetPassword = () => {
  const [rawNewPassword, setRawNewPassword] = React.useState("");
  const [rawRepeatNewPassword, setRawRepeatNewPassword] = React.useState("");

  const isPasswordValid =
    rawNewPassword === rawRepeatNewPassword && rawNewPassword.length > 10;

  const onSubmit = () => {
    if (!isPasswordValid) {
      alert("Passwords do not match or are too short");
      return;
    }

    fetchGraphQL(`
      mutation {
          passwordReset(
              newPassword: "${rawNewPassword}",
          )
      }
    `)
      .then((response) => {
        if (response.errors) {
          alert("Error resetting password");
          return;
        }
        alert("Password reset successfully");
      })
      .catch((error) => {
        console.error("🔴 (RD-697) - ", error);
      });
  };

  return (
    <div className="flex flex-col h-full items-center justify-center text-center gap-2 text-color-dark-text-primary">
      <RaindropMotionFadeUp className="max-w-md w-full">
        <RaindropCard additionalClasses="max-w-md w-full gap-6 p-6">
          <RaindropHeading title="Password Reset" />

          <RaindropInput
            label={"New password"}
            placeholder={"Email"}
            type={"email"}
            value={rawNewPassword}
            onChange={(e) => setRawNewPassword(e.target.value)}
            isFluid={true}
          />
          <RaindropInput
            label={"Repeat new password"}
            placeholder={"Email"}
            type={"email"}
            value={rawRepeatNewPassword}
            onChange={(e) => setRawRepeatNewPassword(e.target.value)}
            isFluid={true}
          />

          <RaindropButton
            title={"Reset password"}
            icon={"fa-paper-plane"}
            isFluid={true}
            style={ButtonStyle.Primary}
            onClick={onSubmit}
          />
        </RaindropCard>
      </RaindropMotionFadeUp>
    </div>
  );
};

export default NimbusResetPassword;
